import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "/models/octavia/safety",
  "description": "В новой OCTAVIA устанавливается до девяти подушек безопасности. По результатам независимых краш-тестов машина получила высший балл — пять звёзд Euro NCAP. Подробный обзор автомобиля, фото, технические характеристики, комплектации  на официальном сайте ŠKODA в России.",
  "huggerTemplate": "default",
  "keywords": "Octavia Safety",
  "name": "octavia-safety",
  "title": "Системы безопасности ŠKODA OCTAVIA | До 9 подушек безопасности в новой Шкода Октавия 2023/2022 - официальный сайт ŠKODA в России"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const SimpleMainStageHeading = makeShortcode("SimpleMainStageHeading");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const QueriedDisclaimer = makeShortcode("QueriedDisclaimer");
const FeaturesSliderQueried = makeShortcode("FeaturesSliderQueried");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const QueriedGallery = makeShortcode("QueriedGallery");
const ListMobileSlider = makeShortcode("ListMobileSlider");
const SlideIcon = makeShortcode("SlideIcon");
const Slider = makeShortcode("Slider");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="bottom" horizontalAlign="right" src="/m/octavia-safety-kv.jpg" mobileSrc="/m/octavia-safety-kv-mob.jpg" mdxType="SimpleMainStage">
  <SimpleMainStageHeading mdxType="SimpleMainStageHeading">Группа поддержки</SimpleMainStageHeading>
    </SimpleMainStage>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionText mdxType="DefaultSectionText">
    То, что ŠKODA OCTAVIA относится к новейшему поколению европейских моделей,
    видно не только по дизайну. Оцените список оборудования, напрямую влияющего
    на безопасность поездок. В нём есть и матричные светодиодные фары, и
    адаптивный круиз-контроль, и камера, отслеживающая дорожную разметку.
    <QueriedDisclaimer tag="oct2020-safety" size={18} mdxType="QueriedDisclaimer" />
  </DefaultSectionText>
  <FeaturesSliderQueried tags="octavia2020-safetypage-asissts" mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">НА КРАЙНИЙ СЛУЧАЙ</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    К сожалению, ДТП всё ещё неизбежны, хотя бы потому, что даже самый
    внимательный и аккуратный водитель на очень хорошем автомобиле не может
    отвечать за всех участников движения. На случай серьёзных столкновений в
    OCTAVIA устанавливается до девяти подушек безопасности. Очень рассчитываем,
    что вам эта информация не пригодится на практике, но сообщим: по результатам
    независимых краш-тестов машина получила высший балл, пять звёзд Euro NCAP.
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedGallery presetName="4" type="modal" tags="octavia2020-safetypage-airbag" mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    Другие средства обеспечения безопасности
  </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Когда речь заходит о безопасности, ŠKODA не допускает компромиссов. Поэтому
    практически в любой OCTAVIA вы найдете в качестве стандартного оборудования
    следующие системы:
  </DefaultSectionText>
  <ListMobileSlider mdxType="ListMobileSlider">
    <SlideIcon icon="/m/icon-check.svg" size="small" title="ABS" text="Предотвращает блокировку колёс при экстренном торможении или при торможении на скользком дорожном покрытии. Благодаря этому автомобиль продолжает слушаться руля до полной остановки." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="Тормозной ассистент" size="small" text="Увеличивает давление в системе, когда водитель бьёт по педали резко — ситуация критическая! — но недостаточно сильно. Это значительно сокращает тормозной путь." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="MSR" size="small" text="Позволяет избежать блокировки ведущих колёс на скользкой дороге, когда водитель слишком быстро отпускает педаль акселератора или некорректно включает низшую передачу." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="ASR" size="small" text="Обеспечивает уверенный разгон без пробуксовки колёс и рыскания автомобиля." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="EDL" size="small" text="Подтормаживает буксующее колесо, чтобы крутящий момент перешёл к другому колесу на той же оси. Существенно повышает проходимость. На полноприводных автомобилях работает на обеих осях." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="XDS+" size="small" text="Подтормаживает разгруженное колесо, которое находится ближе к центру поворота, чтобы больше тяги досталось второму колесу, которое в состоянии реализовать крутящий момент. В итоге повороты автомобиль проходит быстрее и «чище»." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="Ассистент трогания на подъеме" size="small" text="Позволяет начать движение в крутую горку, не откатившись назад и на самую малость. Автоматика поднимет давление в тормозной магистрали на несколько секунд, пока не начнётся движение. Система работает с автоматическими (роботизированными) и механическими коробками передач." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="Мигающие стоп-сигналы" size="small" text="Служит для привлечения внимания окружающих и уменьшает риск наезда сзади. Включается автоматически при очень интенсивном или экстренном торможении." contentMaxWidth="300px" mdxType="SlideIcon" />
  </ListMobileSlider>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" noPt mdxType="DefaultPaddedSection">
  <Slider slidesToShow={1} mdxType="Slider">
    <SlideIcon key="/m/subscribe.svg" icon="/m/subscribe.svg" title="Подписаться" text=" Подпишитесь на новости о ŠKODA" buttonText="Подписаться на новости" buttonLink="/subscribe" mdxType="SlideIcon" />
  </Slider>
    </DefaultPaddedSection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      